import { BACKRS_REGION_OPTIONS } from '@backrs_ui/common-ui/src/models/college';

import {
  SEARCH_CATEGORIES,
  SEARCH_CATEGORIES_SCHOLARSHIPS,
  SEARCH_CATEGORIES_INTERNSHIPS,
  SEARCH_CATEGORIES_COLLEGES,
} from './search.filters';
import { SearchParentCategory, SearchCategory } from './search.types';

export const SEARCH_PARENT_CATEGORIES_DEFAULT: Record<string, SearchParentCategory> = {
  CAREER_OPPORTUNITIES: {
    name: 'Opportunities',
    iconName: 'Luggage02',
    categories: [
      { key: SEARCH_CATEGORIES.CAREER_OPPORTUNITIES_INTERNSHIPS, label: 'Internships' },
      { key: SEARCH_CATEGORIES.CAREER_OPPORTUNITIES_JOBS, label: 'Jobs' },
      { key: SEARCH_CATEGORIES.CAREER_OPPORTUNITIES_CAREER_PATH, label: 'Career Paths' },
    ],
    isInMoreFilters: false,
  },
  SCHOLARSHIPS: {
    name: 'Scholarships',
    iconName: 'Calendar',
    categories: [
      { key: SEARCH_CATEGORIES.SCHOLARSHIPS_SCHOLARSHIPS, label: 'Scholarships' },
      { key: SEARCH_CATEGORIES.SCHOLARSHIPS_FINANCIAL_AID_COMPETENCY, label: 'Financial Aid' },
    ],
    isInMoreFilters: false,
  },
  RESOURCES: {
    name: 'Resources',
    iconName: 'Film03',
    categories: [
      { key: SEARCH_CATEGORIES.RESOURCES_NUGGET_VIDEO, label: 'Videos' },
      { key: SEARCH_CATEGORIES.RESOURCES_NUGGET_BOOK, label: 'Books' },
      { key: SEARCH_CATEGORIES.RESOURCES_NUGGET_ARTICLE, label: 'Articles' },
      { key: SEARCH_CATEGORIES.RESOURCES_COMPETENCY, label: 'Competencies' },
    ],
    isInMoreFilters: false,
  },
  PEOPLE: {
    name: 'People',
    iconName: 'Users01',
    categories: [{ key: SEARCH_CATEGORIES.PEOPLE, label: 'People' }],
    isInMoreFilters: false,
  },
  NUGGET_STORIES: {
    name: 'Stories',
    iconName: 'Film03',
    categories: [{ key: SEARCH_CATEGORIES.NUGGET_STORIES, label: 'Stories' }],
    isInMoreFilters: true,
  },
  NUGGET_GROW_BY_DOING: {
    name: 'Grow By Doing',
    iconName: 'Activity',
    categories: [{ key: SEARCH_CATEGORIES.NUGGET_GROW_BY_DOING, label: 'Grow By Doing' }],
    isInMoreFilters: true,
  },
};

export const SEARCH_PARENT_CATEGORIES_SCHOLARSHIPS: Record<string, SearchParentCategory> = {
  TYPES: {
    name: 'Types',
    iconName: 'Calendar',
    categories: [
      { key: SEARCH_CATEGORIES_SCHOLARSHIPS.TYPE_ALL, label: 'All', clearsOtherFilters: true },
      { key: SEARCH_CATEGORIES_SCHOLARSHIPS.TYPE_SCHOLARSHIPS, label: 'Scholarships' },
      { key: SEARCH_CATEGORIES_SCHOLARSHIPS.TYPE_FORGIVABLE_LOAN, label: 'Forgivable Loans' },
      { key: SEARCH_CATEGORIES_SCHOLARSHIPS.TYPE_GRANT, label: 'Grants' },
      { key: SEARCH_CATEGORIES_SCHOLARSHIPS.TYPE_CORPORATE, label: 'Corporate' },
      { key: SEARCH_CATEGORIES_SCHOLARSHIPS.TYPE_FELLOWSHIP, label: 'Fellowships' },
    ],
    isInMoreFilters: false,
  },
};

export const SEARCH_PARENT_CATEGORIES_INTERNSHIPS: Record<string, SearchParentCategory> = {
  GEOGRAPHY: {
    name: 'Geography',
    iconName: 'Map01',
    categories: [
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_ALL, label: 'All', clearsOtherFilters: true },

      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_ATLANTA, label: 'Atlanta' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_AUSTIN, label: 'Austin' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_BALTIMORE, label: 'Baltimore' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_BIRMINGHAM, label: 'Birmingham' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_BOSTON, label: 'Boston' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_BUFFALO, label: 'Buffalo' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_CHARLOTTE, label: 'Charlotte' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_CHICAGO, label: 'Chicago' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_CINCINNATI, label: 'Cincinnati' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_CLEVELAND, label: 'Cleveland' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_COLUMBUS, label: 'Columbus' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_DALLAS, label: 'Dallas' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_DENVER, label: 'Denver' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_DETROIT, label: 'Detroit' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_HARTFORD, label: 'Hartford' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_HOUSTON, label: 'Houston' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_INDIANAPOLIS, label: 'Indianapolis' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_JACKSONVILLE, label: 'Jacksonville' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_KANSAS_CITY, label: 'Kansas City' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_LAS_VEGAS, label: 'Las Vegas' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_LOS_ANGELES, label: 'Los Angeles' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_LOUISVILLE, label: 'Louisville' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_MEMPHIS, label: 'Memphis' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_MIAMI, label: 'Miami' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_MILWAUKEE, label: 'Milwaukee' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_MINNEAPOLIS, label: 'Minneapolis' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_NASHVILLE, label: 'Nashville' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_NEW_ORLEANS, label: 'New Orleans' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_NEW_YORK, label: 'New York' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_OKLAHOMA_CITY, label: 'Oklahoma City' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_ORLANDO, label: 'Orlando' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_PHILADELPHIA, label: 'Philadelphia' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_PHOENIX, label: 'Phoenix' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_PITTSBURGH, label: 'Pittsburgh' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_PORTLAND, label: 'Portland' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_PROVIDENCE, label: 'Providence' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_RALEIGH, label: 'Raleigh' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_RICHMOND, label: 'Richmond' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_RIVERSIDE, label: 'Riverside' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_SACRAMENTO, label: 'Sacramento' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_SALT_LAKE_CITY, label: 'Salt Lake City' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_SAN_ANTONIO, label: 'San Antonio' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_SAN_DIEGO, label: 'San Diego' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_SAN_FRANCISCO, label: 'San Francisco' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_SAN_JOSE, label: 'San Jose' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_SEATTLE, label: 'Seattle' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_ST_LOUIS, label: 'St. Louis' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_TAMPA, label: 'Tampa' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_VIRGINIA_BEACH, label: 'Virginia Beach' },
      { key: SEARCH_CATEGORIES_INTERNSHIPS.MSA_WASHINGTON, label: 'Washington' },
    ],
    isInMoreFilters: false,
  },
  JOB_TYPE: {
    name: 'Job Type',
    iconName: 'Clipboard',
    categories: [
      { key: SEARCH_CATEGORIES_INTERNSHIPS.JOB_TYPE_ALL, label: 'All', clearsOtherFilters: true },
      { key: SEARCH_CATEGORIES.CAREER_OPPORTUNITIES_INTERNSHIPS, label: 'Internships' },
      { key: SEARCH_CATEGORIES.CAREER_OPPORTUNITIES_JOBS, label: 'Jobs' },
    ],
    isInMoreFilters: false,
  },
};

export const SEARCH_PARENT_CATEGORIES_COLLEGES: Record<string, SearchParentCategory> = {
  // TYPE: {
  //   name: 'School Type',
  //   iconName: 'Building04',
  //   isInMoreFilters: false,
  //   categories: [
  //     {
  //       key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_TYPE_ALL,
  //       label: 'All',
  //       clearsOtherFilters: true,
  //     },
  //     { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_TYPE_FOUR_YEAR, label: 'Four-Year' },
  //     { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_TYPE_TWO_YEAR, label: 'Two-Year' },
  //   ],
  // },
  SIZE: {
    name: 'Size',
    iconName: 'Users01',
    isInMoreFilters: false,
    categories: [
      {
        key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_SIZE_ALL,
        label: 'All',
        clearsOtherFilters: true,
      },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_SIZE_VERY_SMALL, label: 'Very Small' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_SIZE_SMALL, label: 'Small' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_SIZE_MEDIUM, label: 'Medium' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_SIZE_LARGE, label: 'Large' },
    ],
  },
  REGION: {
    name: 'Region',
    iconName: 'Globe01',
    isInMoreFilters: false,
    categories: [
      {
        key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_REGION_ALL,
        label: 'All',
        clearsOtherFilters: true,
      },
      ...Object.entries(BACKRS_REGION_OPTIONS).map(([key, value]) => ({
        key: `COLLEGE_REGION_${key}` as SearchCategory,
        label: value,
      })),
    ],
  },
  STATE: {
    name: 'State',
    iconName: 'Flag01',
    isInMoreFilters: false,
    categories: [
      {
        key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_ALL,
        label: 'All',
        clearsOtherFilters: true,
      },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_ALABAMA, label: 'Alabama' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_ALASKA, label: 'Alaska' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_ARIZONA, label: 'Arizona' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_ARKANSAS, label: 'Arkansas' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_CALIFORNIA, label: 'California' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_COLORADO, label: 'Colorado' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_CONNECTICUT, label: 'Connecticut' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_DELAWARE, label: 'Delaware' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_FLORIDA, label: 'Florida' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_GEORGIA, label: 'Georgia' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_HAWAII, label: 'Hawaii' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_IDAHO, label: 'Idaho' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_ILLINOIS, label: 'Illinois' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_INDIANA, label: 'Indiana' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_IOWA, label: 'Iowa' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_KANSAS, label: 'Kansas' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_KENTUCKY, label: 'Kentucky' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_LOUISIANA, label: 'Louisiana' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_MAINE, label: 'Maine' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_MARYLAND, label: 'Maryland' },
      {
        key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_MASSACHUSETTS,
        label: 'Massachusetts',
      },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_MICHIGAN, label: 'Michigan' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_MINNESOTA, label: 'Minnesota' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_MISSISSIPPI, label: 'Mississippi' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_MISSOURI, label: 'Missouri' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_MONTANA, label: 'Montana' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_NEBRASKA, label: 'Nebraska' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_NEVADA, label: 'Nevada' },
      {
        key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_NEW_HAMPSHIRE,
        label: 'New Hampshire',
      },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_NEW_JERSEY, label: 'New Jersey' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_NEW_MEXICO, label: 'New Mexico' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_NEW_YORK, label: 'New York' },
      {
        key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_NORTH_CAROLINA,
        label: 'North Carolina',
      },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_NORTH_DAKOTA, label: 'North Dakota' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_OHIO, label: 'Ohio' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_OKLAHOMA, label: 'Oklahoma' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_OREGON, label: 'Oregon' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_PENNSYLVANIA, label: 'Pennsylvania' },
      {
        key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_RHODE_ISLAND,
        label: 'Rhode Island',
      },
      {
        key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_SOUTH_CAROLINA,
        label: 'South Carolina',
      },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_SOUTH_DAKOTA, label: 'South Dakota' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_TENNESSEE, label: 'Tennessee' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_TEXAS, label: 'Texas' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_UTAH, label: 'Utah' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_VERMONT, label: 'Vermont' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_VIRGINIA, label: 'Virginia' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_WASHINGTON, label: 'Washington' },
      {
        key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_WEST_VIRGINIA,
        label: 'West Virginia',
      },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_WISCONSIN, label: 'Wisconsin' },
      { key: SEARCH_CATEGORIES_COLLEGES.COLLEGE_STATE_WYOMING, label: 'Wyoming' },
    ],
  },
};
